import { AttributeEditorDialogViewModel } from '@Alternatives/Attributes/Components/AttributeEditorDialog';
import AttributeEditorDialog from '@Alternatives/Attributes/Components/AttributeEditorDialog.vue';
import AttributesQueries from '@Alternatives/Attributes/Domain/queries-vue-component';
import { AttributeEditorReadModel, AttributeReadModel } from '@Alternatives/Attributes/Domain/readmodels';
import { DownloadBlob } from '@browser/Browser';
import * as rt from "@common/AppRT";
import { generateName, strCompareLowerCase } from '@common/Common';
import GoalNavigation from "@common/Components/GoalNavigation.vue";
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { dynamicUiRoutes } from '@common/dynamicUiRoutes';
import { ICommandStatus } from '@cqrs/cqrs';
import { ScoresExporterViewModel } from '@Evaluation/AlternativesSurveys/Components/ScoresExporter';
import ScoresExporter from '@Evaluation/AlternativesSurveys/Components/ScoresExporter.vue';
import { ScoringSurveyAccessLinksViewModel } from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyAccessLinks';
import ScoringSurveyAccessLinks from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyAccessLinks.vue';
import { ScoringSurveyEmailSenderViewModel } from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyEmailSender';
import ScoringSurveyEmailSender from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyEmailSender.vue';
import { SubSurveysManagerDialogViewModel } from '@Evaluation/AlternativesSurveys/Components/SubSurveysManagerDialog';
import SubSurveysManagerDialog from '@Evaluation/AlternativesSurveys/Components/SubSurveysManagerDialog.vue';
import { SurveyAlternativesManagerDialogSaveEventPayload, SurveyAlternativesManagerDialogViewModel } from '@Evaluation/AlternativesSurveys/Components/SurveyAlternativesManagerDialog';
import SurveyAlternativesManagerDialog from '@Evaluation/AlternativesSurveys/Components/SurveyAlternativesManagerDialog.vue';
import SurveyCloserDialog from '@Evaluation/AlternativesSurveys/Components/SurveyCloserDialog.vue';
import { SurveyCriteriaManagerDialogViewModel } from '@Evaluation/AlternativesSurveys/Components/SurveyCriteriaManagerDialog';
import SurveyCriteriaManagerDialog from '@Evaluation/AlternativesSurveys/Components/SurveyCriteriaManagerDialog.vue';
import { SurveyEditorDialogViewModel } from '@Evaluation/AlternativesSurveys/Components/SurveyEditorDialog';
import SurveyEditorDialog from '@Evaluation/AlternativesSurveys/Components/SurveyEditorDialog.vue';
import SurveyOpenerDialog from '@Evaluation/AlternativesSurveys/Components/SurveyOpenerDialog.vue';
import { ChangeSubSurveyVoteStrengthCommandV1, CreateSurveyCommandV1, DeleteSurveyCommandV1, ExcludeSubSurveyCommandV1, ExportAllScoringVotesToXlsCommandV1, ExportSurveyScoresToAttributesCommandV1, IncludeSubSurveyCommandV1, SendEmailCommandV1, StartSurveyCommandV1, StopSurveyCommandV1, UpdateSurveyAlternativesCommandV1, UpdateSurveyCommandV1, UpdateSurveyCriteriaCommandV1 } from '@Evaluation/AlternativesSurveys/Domain/commands-core';
import ScoringCommands from '@Evaluation/AlternativesSurveys/Domain/commands-vue-component';
import ScoringQueries from '@Evaluation/AlternativesSurveys/Domain/queries-vue-component';
import { ScoresExporterPreviewReadModel, ScoresExporterReadModel, ScoringAlternativeDescriptionReadModel, ScoringAlternativesListReadModel, ScoringDownloadAccessLinksReadModel, ScoringSurveyPanelistsReadModel, ScoringSurveyReadModel, ScoringSurveysPageReadModel, SubSurveysManagerReadModel, SurveyAlternativesManagerReadModel, SurveyCriteriaManagerReadModel } from '@Evaluation/AlternativesSurveys/Domain/readmodels';
import { IEvaluationCommand } from '@Evaluation/cqrs';
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        GoalNavigation, PortfolioOrDecisionNavigation, SurveyOpenerDialog, SurveyCloserDialog, ScoresExporter, AttributeEditorDialog,
        SurveyEditorDialog, SubSurveysManagerDialog, SurveyCriteriaManagerDialog, SurveyAlternativesManagerDialog, ScoringSurveyAccessLinks, ScoringSurveyEmailSender
    }
})
export default class ScoringSurveysPage extends mixins(ScoringQueries, ScoringCommands, AttributesQueries)
{ 
    get workspaceId(): number { return Number(this.$route?.params?.workspaceId ?? 0); }
    get projectId(): number { return Number(this.$route?.params?.projectId ?? 0); }
    get evalModelId(): number { return Number(this.$route?.params?.evalModelId ?? 0); }

    rm: ScoringSurveysPageReadModel | null = null;

    scoresExporter = new ScoresExporterViewModel();
    attributeEditorDialog: AttributeEditorDialogViewModel = new AttributeEditorDialogViewModel();
    surveyEditorDialog: SurveyEditorDialogViewModel = new SurveyEditorDialogViewModel();
    subSurveysManagerDialog: SubSurveysManagerDialogViewModel = new SubSurveysManagerDialogViewModel();
    surveyCriteriaManagerDialog: SurveyCriteriaManagerDialogViewModel = new SurveyCriteriaManagerDialogViewModel();
    surveyAlternativesManagerDialog: SurveyAlternativesManagerDialogViewModel = new SurveyAlternativesManagerDialogViewModel();
    scoringSurveyAccessLinks: ScoringSurveyAccessLinksViewModel = new ScoringSurveyAccessLinksViewModel();
    scoringSurveyEmailSender: ScoringSurveyEmailSenderViewModel = new ScoringSurveyEmailSenderViewModel();
    surveyOpenerSurveyId: number | null = null;
    surveyCloserSurveyId: number | null = null;

    url_ScoringPanelistsPage(surveyId: number): string
    {
        return dynamicUiRoutes.Evaluation_ScoringPanelistsPage(this.$route, this.workspaceId, this.projectId, this.evalModelId, surveyId);
    }

    url_ScoringMeetingManagerPage(surveyId: number): string
    {
        return dynamicUiRoutes.Evaluation_ScoringMeetingManagerPage(this.$route, this.workspaceId, this.projectId, this.evalModelId, surveyId);
    }

    get surveysView() { return this.rm?.Surveys.sort((a, b) => strCompareLowerCase(a.Name, b.Name)); }

    showSurveyCriteriaManager(surveyId: number)         
    {
        const s = this.rm.Surveys.find(a => a.Id === surveyId);
        this.surveyCriteriaManagerDialog.show(s.Id, s.Name);
        this.runSurveyCriteriaManagerQueryV1(this.workspaceId, this.projectId, this.evalModelId, s.Id);
    }


    showSurveyAlternativesManager(surveyId: number)
    {
        const s = this.rm.Surveys.find(a => a.Id === surveyId);
        this.surveyAlternativesManagerDialog.show(s.Id, s.Name, this.rm.AlternativesLabel);
        this.runSurveyAlternativesManagerQueryV1(this.workspaceId, this.projectId, this.evalModelId, s.Id);
    }

    showSurveyOpener(surveyId: number)
    {
        this.surveyOpenerSurveyId = surveyId;
    }

    showSurveyCloser(surveyId: number)
    {
        this.surveyCloserSurveyId = surveyId;
    }

    showAttributeCreator()
    {
        this.attributeEditorDialog.showCreator({
            defaultName: generateName("Attribute"),
            allowChangeAttributeType: false,
            allowMultipleValuesEnabled: false,
            allowInputTypeEvaluate: false,
        });

        this.runAttributeEditorQueryV1(this.workspaceId, this.projectId, null);
    }

    showSurveyCreator()
    {
        this.surveyEditorDialog.showCreator(generateName("Survey"));
    }

    showSurveyEditor(s: ScoringSurveyReadModel)
    {
        this.surveyEditorDialog.showEditor(s.Id, s.Name, s.Description);
    }

    showAccessLinks(surveyId: number)
    {
        this.scoringSurveyAccessLinks.show(surveyId);
        this.runScoringAccessLinksBySurveyIdQueryV1(this.workspaceId, surveyId);
    }


    showSubSurveysManager(surveyId: number)
    {
        const s = this.rm.Surveys.find(a => a.Id === surveyId);
        this.subSurveysManagerDialog.show(s.Id, s.Name);
        this.runSubSurveysManagerQueryV1(this.workspaceId, this.projectId, this.evalModelId, s.Id);
    }

    showScoresExporter(surveyId: number)         
    {
        this.scoresExporter.show(surveyId);
        this.runScoresExporterQueryV1(this.workspaceId, this.projectId, this.evalModelId, surveyId)
    }

    closeScoresExporter()         
    {
        this.scoresExporter.close();
    }


    numericAttributeCreated(attrId: number, maxValue: number | null)
    {
        this.runAttributeByIdQueryV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, attrId);
    }


    loadScoresExporterPreview(mappings: any[])
    {
        this.runScoresExporterPreviewQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.scoresExporter.surveyId, mappings);
    }

    handleLoadAlternativesByList(viewDefId: string)
    {
        this.runFilterAlternativesByListQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.rm.AlternativesListId, viewDefId);
    }

    handleLoadAlternativeDescription(alternativeId: string, descriptionTemplate: string)
    {
        this.runAlternativeDescriptionQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.rm.AlternativesListId, alternativeId, descriptionTemplate);
    }

    resetScoresExporterPreview()
    {
        this.scoresExporter.preview = null;
    }


    handleExportSurveyScoresToAttributesCommand(mappings: any[])
    {
        this.invokeExportSurveyScoresToAttributesCommandV1(this.rm.UserId, this.workspaceId, this.projectId, this.evalModelId, this.scoresExporter.surveyId, mappings);
    }

    handleExportAllScoringVotesToXlsCommand()
    {
        this.invokeExportAllScoringVotesToXlsCommandV1(this.workspaceId, this.projectId, this.evalModelId, 0);
    }



    confirmSurveyDelete(s: ScoringSurveyReadModel)
    {
        if (confirm(`Do you want to delete ${s.Name}?`))
        {
            this.handleDeleteSurveyCommand(s.Id);
        }
    }

    handleShowEmailSender(surveyId: number, puIds: number[])
    {
        this.scoringSurveyEmailSender.show(surveyId, puIds);
    }

    handleSendEmailCommand(emailSubject: string, emailBody: string)
    {
        const sender = this.scoringSurveyEmailSender;
        this.invokeSendEmailCommandV1(this.workspaceId, sender.surveyId, sender.projectUserIds, emailSubject, emailBody);
    }

    handleDownloadAccessLinks(surveyId: number)
    {
        this.runExportScoringAccessLinksBySurveyIdQueryV1(this.workspaceId, surveyId);
    }


    handleDeleteSurveyCommand(surveyId: number)
    {
        this.invokeDeleteSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, surveyId);
    }

    handleCreateSurveyCommand(surveyId: number, name: string, description: string)
    {
        this.invokeCreateSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, surveyId, name, description);
    }

    handleUpdateSurveyCommand(surveyId: number, name: string, description: string)
    {
        this.invokeUpdateSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, surveyId, name, description);
    }

    handleIncludeSubSurveyCommand(masterSurveyId: number, subSurveyId: number, voteStrength: number)
    {
        this.invokeIncludeSubSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, masterSurveyId, subSurveyId, voteStrength);
    }

    handleChangeSubSurveyVoteStrengthCommand(masterSurveyId: number, subSurveyId: number, voteStrength: number)
    {
        this.invokeChangeSubSurveyVoteStrengthCommandV1(this.workspaceId, this.projectId, this.evalModelId, masterSurveyId, subSurveyId, voteStrength);
    }

    handleExcludeSubSurveyCommand(masterSurveyId: number, subSurveyId: number)
    {
        this.invokeExcludeSubSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, masterSurveyId, subSurveyId);
    }

    handleStopSurveyCommand(surveyId: number) 
    {
        this.invokeStopSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, surveyId);
    }

    handleStartSurveyCommand(surveyId: number) 
    {
        this.invokeStartSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, surveyId);
    }

    handleUpdateSurveyCriteriaCommand(surveyId: number, criteriaIds: number[])
    {
        this.invokeUpdateSurveyCriteriaCommandV1(this.workspaceId, this.projectId, this.evalModelId, surveyId, criteriaIds);
    }

    handleUpdateSurveyAlternativesCommand(e: SurveyAlternativesManagerDialogSaveEventPayload)
    {
        this.invokeUpdateSurveyAlternativesCommandV1(this.workspaceId, this.projectId, this.evalModelId, e.id, e.alternativeIds, e.descriptionTemplate);
    }


    mounted()
    {
        document.title = "Scoring | TransparentChoice";
        this.runScoringSurveysPageQueryV1(this.workspaceId, this.projectId, this.evalModelId);
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName == "ScoringSurveysPageReadModel")
        {
            this.rm = model as ScoringSurveysPageReadModel;
        }
        else if (modelName == "ScoringSurveyReadModel")
        {
            const s = model as ScoringSurveyReadModel;
            this.rm.Surveys = this.rm.Surveys.filter(a => a.Id !== s.Id);
            this.rm.Surveys.push(s);

            this.surveyAlternativesManagerDialog.close();
            this.surveyCriteriaManagerDialog.close();
            this.surveyEditorDialog.close();
        }
        else if (modelName === "SubSurveysManagerReadModel")
        {
            const rm = model as SubSurveysManagerReadModel;
            this.subSurveysManagerDialog.setData(rm);
        }
        else if (modelName === "SurveyCriteriaManagerReadModel")
        {
            const rm = model as SurveyCriteriaManagerReadModel;
            this.surveyCriteriaManagerDialog.setData(rm);
        }
        else if (modelName === "SurveyAlternativesManagerReadModel")
        {
            const rm = model as SurveyAlternativesManagerReadModel;
            this.surveyAlternativesManagerDialog.setData(rm);
        }
        else if (modelName == "ScoresExporterReadModel")
        {
            const rm = model as ScoresExporterReadModel;
            this.scoresExporter.init(rm);
        }
        else if (modelName === "ScoresExporterPreviewReadModel")
        {
            const rm = model as ScoresExporterPreviewReadModel;
            this.scoresExporter.setPreview(rm);
        }
        else if (modelName === "AttributeReadModel")
        {
            const rm = model as AttributeReadModel;
            if (this.scoresExporter.attributes.some(a => a.Id === rm.Id)) return;
            this.scoresExporter.attributes.push(rm);
        }
        else if (modelName === "ScoringAlternativesListReadModel")
        {
            const rm = model as ScoringAlternativesListReadModel;
            this.surveyAlternativesManagerDialog.filteredByIds(rm.Alternatives.map(a => a.Id));
        }
        else if (modelName === "ScoringAlternativeDescriptionReadModel")
        {
            const rm = model as ScoringAlternativeDescriptionReadModel;
            this.surveyAlternativesManagerDialog.setPreview(rm.Description);
        }
        else if (modelName == "ScoringSurveyPanelistsReadModel")
        {
            const rm = model as ScoringSurveyPanelistsReadModel;
            this.scoringSurveyAccessLinks.setData(rm);
        }
        else if (modelName === "ScoringDownloadAccessLinksReadModel")
        {
            const rm = model as ScoringDownloadAccessLinksReadModel;
            DownloadBlob(rm.Url);
        }
        else if (modelName === "AttributeEditorReadModel")
        {
            const rm = model as AttributeEditorReadModel;
            this.attributeEditorDialog.setData(rm);
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string, result: any)
    {
        if (ExportSurveyScoresToAttributesCommandV1.matchType(cmd))
        {
            this.scoresExporter.close();
            alert('Saved');
        }
        else if (DeleteSurveyCommandV1.matchType(cmd))
        {
            this.rm.Surveys = this.rm.Surveys.filter(a => a.Id !== Number(correlationId));
            this.surveyEditorDialog.close();
        }
        else if (CreateSurveyCommandV1.matchType(cmd))
        {
            const surveyId = Number(result);
            this.runScoringSurveyQueryV1(this.workspaceId, this.projectId, this.evalModelId, surveyId)
            this.surveyEditorDialog.close();
            this.showSurveyAlternativesManager(surveyId);
        }
        else if (UpdateSurveyCommandV1.matchType(cmd))
        {
            const surveyId = Number(correlationId);
            this.runScoringSurveyQueryV1(this.workspaceId, this.projectId, this.evalModelId, surveyId)
        }
        else if (IncludeSubSurveyCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as IncludeSubSurveyCommandV1;

            this.rm.Surveys.find(s => s.Id == Number.parseInt(cmd1.Id)).SubSurveysCount++;
            this.subSurveysManagerDialog.includeSubSurvey(Number(correlationId), cmd1.VoteStrength);
        }
        else if (ExcludeSubSurveyCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as ExcludeSubSurveyCommandV1;

            this.rm.Surveys.find(s => s.Id == Number.parseInt(cmd1.Id)).SubSurveysCount--;
            this.subSurveysManagerDialog.excludeSubSurvey(Number(correlationId));
        }
        else if (ChangeSubSurveyVoteStrengthCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as ChangeSubSurveyVoteStrengthCommandV1;

            this.subSurveysManagerDialog.changeSubSurveyVoteStrength(Number(correlationId), cmd1.VoteStrength);
        }
        else if (StartSurveyCommandV1.matchType(cmd))
        {
            const surveyId = Number(correlationId);

            this.rm.Surveys.find(s => s.Id === surveyId).SurveyStarted = true;

            rt.send("Scoring.HostMessagePublisher", "SurveyStarted",
                {
                    SurveyId: surveyId,
                    WorkspaceId: this.workspaceId
                });

            this.surveyOpenerSurveyId = null;
        }
        else if (StopSurveyCommandV1.matchType(cmd))
        {
            const surveyId = Number(correlationId);

            this.rm.Surveys.find(s => s.Id == Number(correlationId)).SurveyStarted = false;

            rt.send("Scoring.HostMessagePublisher", "SurveyStopped",
                {
                    SurveyId: surveyId,
                    WorkspaceId: this.workspaceId
                });

            this.surveyCloserSurveyId = null;
        }
        else if (UpdateSurveyCriteriaCommandV1.matchType(cmd))
        {
            this.runScoringSurveyQueryV1(this.workspaceId, this.projectId, this.evalModelId, Number(correlationId));
        }
        else if (UpdateSurveyAlternativesCommandV1.matchType(cmd))
        {
            this.runScoringSurveyQueryV1(this.workspaceId, this.projectId, this.evalModelId, Number(correlationId));
        }
        else if (ExportAllScoringVotesToXlsCommandV1.matchType(cmd))
        {
            location.href = result;
        }
        else if (SendEmailCommandV1.matchType(cmd))
        {
            alert("Sent");
            this.scoringSurveyEmailSender.close();
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (CreateSurveyCommandV1.matchType(status.Command))
        {
            this.surveyEditorDialog.displayValidationErrors(status.ValidationErrors);
        }
        else if (UpdateSurveyCommandV1.matchType(status.Command))
        {
            this.surveyEditorDialog.displayValidationErrors(status.ValidationErrors);
        }
        else if (IncludeSubSurveyCommandV1.matchType(status.Command))
        {
            alert(status.Error);
        }
    }

    onSetQueryError(query: any, error: string)
    {
        console.log(query);
        alert(error);
    }
}